import request from "@/CommonDP/utils/request";
export default {
    //可以查看的项目列表
    getProjectCurrentUser(params) {
        return request.post(`/project/page/currentUser`, params).then(res => res);
    },

    /**获取当前登录人有权限的项目列表 */
    getPrjsByUserId(eId) {
        return request.get(`/project/getProjectsByUserId?enterpriseId=${eId}`)
    },
    //消息列表
    getMessageList(params) {
        return request.post(`/message/list`, params).then(res => res);
    },
    //最近浏览的文件
    getuserRecentViewFile(pageNum, pageSize, enterpriseId) {
        return request.get(`/lc/file/userRecentViewFile/page?pageNum=${pageNum}&pageSize=${pageSize}&enterpriseId=${enterpriseId}`).then(res => res);
    },
    // 清空最近文件记录
    clearRecentView(){
        return request.get('/lc/file/userRecentViewFile/clear')
    },
    queryRoleListNew(prjId) {
        return request.get(`/prjRole/role/tree?prjId=${prjId}`)
    },
}